import {getPriceForCountry} from './getPriceForCountry'

// Professionally Designed Website exists either as its own standalone add-on
// (addon-5-website_difm) or as a free entitlement bundled on certain Center
// plans (ent-5-website, e.g. Marketing/Business Center Pro) — the two are
// mutually exclusive (see productSelectionRules.js). Selecting either form
// triggers the one-time Website Design Fee below, unless the customer has an
// existing published site to transfer (see WebsiteSettingsModal).
export const WEBSITE_ADDON_CODE = 'addon-5-website_difm'
export const WEBSITE_ENTITLEMENT_CODE = 'ent-5-website'

export const WEBSITE_DESIGN_FEE_PLAN = {
  code: 'thryvdesg2',
  name: 'Website Design Fee',
  currencies: [
    {currency: 'AUD', unitAmount: '209.00'},
    {currency: 'BBD', unitAmount: '298.00'},
    {currency: 'CAD', unitAmount: '179.00'},
    {currency: 'KYD', unitAmount: '122.18'},
    {currency: 'NZD', unitAmount: '229.00'},
    {currency: 'USD', unitAmount: '149.00'},
  ],
}

export function getWebsiteDesignFeePrice(selectedCountry) {
  return getPriceForCountry(WEBSITE_DESIGN_FEE_PLAN.currencies, selectedCountry)
}
